import { useEffect, useState } from "react";
import { getEnvStorageKey } from "../../../../utils/environment";

const WORKFLOWS_STORAGE_KEY = getEnvStorageKey("workflows_custom");

const DEFAULT_WORKFLOWS_TEMPLATES = [
  {
    title: "Stale Gap Escalation",
    description:
      "When a high-severity gap is stale > 14 days and has no assignee, then email the CISO to highlight the risk.",
    triggers: [
      {
        id: "high_severity_gap",
        name: "High-Severity Gap",
        description: "When a high severity gap is detected",
        type: "security",
        nextConditions: ["tool_check", "asset_type_check", "assignee_check"],
      },
    ],
    conditions: [
      {
        id: "asset_type_is_Sensitive Data",
        name: "Sensitive Data",
        description: "PII",
        type: {
          id: "asset_type_is",
          name: "Asset type is",
          description: "Check the asset type",
          type: "asset",
        },
        typeChildren: "Sensitive Data",
        fullName: "Asset type is Sensitive Data",
      },
      {
        id: "duration_is_14_days",
        name: "Over 14 days",
        description: "14",
        type: {
          id: "duration_is",
          name: "Duration is",
          description: "Check how long it has existed",
          type: "time",
        },
        typeChildren: "14",
        fullName: "Duration is Over 14 days",
      },
    ],
    actions: [
      {
        id: "create_ticket",
        name: "Create ticket",
        description: "Create a ticket in your ticketing system",
        type: "ticketing",
        config: {
          project: {
            type: "select",
            options: ["Security Engineering", "IT Operations", "DevOps"],
          },
          issueType: {
            type: "select",
            options: ["Epic", "Story", "Task", "Bug"],
          },
          summary: {
            type: "text",
            placeholder: "Issue Summary is Taken from gap",
          },
          description: {
            type: "text",
            placeholder: "Issue description is Taken from Gap",
          },
          assignee: {
            type: "select",
            options: ["Team-member", "Manager", "CISO"],
          },
          labels: {
            type: "multi-select",
            options: ["crowdstrike", "jamf", "okta", "breeze"],
          },
        },
        configValues: {
          project: "IT Operations",
          issueType: "Task",
          summary: "Stale high-severity gap requires attention",
          description: "Critical security gap has been open for over 14 days",
          assignee: "Manager",
          labels: ["security", "high-priority"],
        },
      },
      {
        id: "send_slack",
        name: "Send Slack Message",
        description: "Send a notification to Slack channel",
        type: "notification",
        config: {
          channel: {
            type: "select",
            options: ["#security", "#alerts", "#devops"],
          },
          message: {
            type: "text",
            placeholder: "Custom message",
          },
          mentions: {
            type: "multi-select",
            options: ["@channel", "@here", "@security-team"],
          },
        },
        configValues: {
          channel: "#security",
          message:
            "High-severity gap escalation - requires immediate attention",
          mentions: ["@security-team"],
        },
      },
    ],
    createdAt: "2024-01-15T10:00:00Z",
    createdBy: "John Doe",
    inUse: true,
    available: true,
    id: 1,
  },
  {
    title: "Attack Surface Alert",
    description:
      "When a new applicable attack path with active events is detected, then send a Slack notification to the SecOps channel.",
    triggers: [
      {
        id: "attacker_activity",
        name: "Attacker Activity",
        description: "When suspicious attacker activity is detected",
        type: "threat",
        nextConditions: ["asset_type_check", "severity_check"],
      },
    ],
    conditions: [
      {
        id: "asset_type_is_Key People",
        name: "Key People",
        description: "Admins",
        type: {
          id: "asset_type_is",
          name: "Asset type is",
          description: "Check the asset type",
          type: "asset",
        },
        typeChildren: "Key People",
        fullName: "Asset type is Key People",
      },
    ],
    actions: [
      {
        id: "send_slack",
        name: "Send Slack Message",
        description: "Send a notification to Slack channel",
        type: "notification",
        config: {
          channel: {
            type: "select",
            options: ["#security", "#alerts", "#devops"],
          },
          message: {
            type: "text",
            placeholder: "Custom message",
          },
          mentions: {
            type: "multi-select",
            options: ["@channel", "@here", "@security-team"],
          },
        },
        configValues: {
          channel: "#alerts",
          message:
            "Critical attack surface alert - immediate investigation required",
          mentions: ["@channel", "@security-team"],
        },
      },
    ],
    createdAt: "2024-01-10T14:30:00Z",
    createdBy: "John Doe",
    inUse: false,
    available: true,
    id: 2,
  },
  {
    title: "Critical Asset Protection",
    description:
      "When a critical asset is affected by a high-severity gap, create a ticket and notify the security team.",
    triggers: [
      {
        id: "high_severity_gap",
        name: "High-Severity Gap",
        description: "When a high severity gap is detected",
        type: "security",
        nextConditions: ["tool_check", "asset_type_check", "assignee_check"],
      },
    ],
    conditions: [
      {
        id: "asset_type_is_Internal Application",
        name: "Internal Application",
        description: "Apps",
        type: {
          id: "asset_type_is",
          name: "Asset type is",
          description: "Check the asset type",
          type: "asset",
        },
        typeChildren: "Internal Application",
        fullName: "Asset type is Internal Application",
      },
      {
        id: "severity_is_critical",
        name: "Critical",
        description: "Critical",
        type: {
          id: "severity_is",
          name: "Severity is",
          description: "Check the severity level",
          type: "severity",
        },
        typeChildren: "CRITICAL",
        fullName: "Severity is Critical",
      },
    ],
    actions: [
      {
        id: "create_ticket",
        name: "Create ticket",
        description: "Create a ticket in your ticketing system",
        type: "ticketing",
        config: {
          project: {
            type: "select",
            options: ["Security Engineering", "IT Operations", "DevOps"],
          },
          issueType: {
            type: "select",
            options: ["Epic", "Story", "Task", "Bug"],
          },
          summary: {
            type: "text",
            placeholder: "Issue Summary is Taken from gap",
          },
          description: {
            type: "text",
            placeholder: "Issue description is Taken from Gap",
          },
          assignee: {
            type: "select",
            options: ["Team-member", "Manager", "CISO"],
          },
          labels: {
            type: "multi-select",
            options: ["crowdstrike", "jamf", "okta", "breeze"],
          },
        },
        configValues: {
          project: "Security Engineering",
          issueType: "Bug",
          summary: "Critical asset security vulnerability",
          description:
            "High-severity gap affecting critical internal application",
          assignee: "CISO",
          labels: ["critical", "security", "internal-app"],
        },
      },
      {
        id: "send_slack",
        name: "Send Slack Message",
        description: "Send a notification to Slack channel",
        type: "notification",
        config: {
          channel: {
            type: "select",
            options: ["#security", "#alerts", "#devops"],
          },
          message: {
            type: "text",
            placeholder: "Custom message",
          },
          mentions: {
            type: "multi-select",
            options: ["@channel", "@here", "@security-team"],
          },
        },
        configValues: {
          channel: "#security",
          message:
            "Critical asset protection alert - internal application at risk",
          mentions: ["@here", "@security-team"],
        },
      },
    ],
    createdAt: "2024-01-08T09:15:00Z",
    createdBy: "John Doe",
    inUse: false,
    available: false,
    missingTools: ["Jira"],
    id: 3,
  },
  {
    title: "CISO Email Escalation",
    description:
      "When a high-severity gap is stale > 14 days and has no assignee, then email the CISO to highlight the risk.",
    triggers: [
      {
        id: "high_severity_gap",
        name: "High-Severity Gap",
        description: "When a high severity gap is detected",
        type: "security",
        nextConditions: ["tool_check", "asset_type_check", "assignee_check"],
      },
    ],
    conditions: [
      {
        id: "has_assignee_no",
        name: "No",
        description: "No",
        type: {
          id: "has_assignee",
          name: "Has assignee",
          description: "Check if there's an assignee",
          type: "assignment",
        },
        typeChildren: "NO_ASSIGNEE",
        fullName: "Has assignee No",
      },
      {
        id: "duration_is_14_days",
        name: "Over 14 days",
        description: "14",
        type: {
          id: "duration_is",
          name: "Duration is",
          description: "Check how long it has existed",
          type: "time",
        },
        typeChildren: "14",
        fullName: "Duration is Over 14 days",
      },
    ],
    actions: [
      {
        id: "send_email",
        name: "Email CISO",
        description: "Send email notification to CISO",
        type: "notification",
        config: {
          recipient: {
            type: "select",
            options: ["CISO", "Security Team", "IT Manager"],
          },
          subject: {
            type: "text",
            placeholder: "Email subject",
          },
          template: {
            type: "select",
            options: ["Security Alert", "Gap Escalation", "Custom"],
          },
        },
        configValues: {
          recipient: "CISO",
          subject: "Urgent: Unassigned high-severity gap requires attention",
          template: "Gap Escalation",
        },
      },
    ],
    createdAt: "2024-01-05T16:45:00Z",
    createdBy: "John Doe",
    inUse: false,
    available: false,
    id: 4,
  },
];

const DEFAULT_WORKFLOWS = [
  {
    title: "Stale Gap Escalation",
    description:
      "When a high-severity gap is stale > 14 days and has no assignee, then email the CISO to highlight the risk.",
    triggers: [
      {
        id: "high_severity_gap",
        name: "High-Severity Gap",
        description: "When a high severity gap is detected",
        type: "security",
        nextConditions: ["tool_check", "asset_type_check", "assignee_check"],
      },
    ],
    conditions: [
      {
        id: "asset_type_is_Sensitive Data",
        name: "Sensitive Data",
        description: "PII",
        type: {
          id: "asset_type_is",
          name: "Asset type is",
          description: "Check the asset type",
          type: "asset",
        },
        typeChildren: "Sensitive Data",
        fullName: "Asset type is Sensitive Data",
      },
      {
        id: "duration_is_14_days",
        name: "Over 14 days",
        description: "14",
        type: {
          id: "duration_is",
          name: "Duration is",
          description: "Check how long it has existed",
          type: "time",
        },
        typeChildren: "14",
        fullName: "Duration is Over 14 days",
      },
    ],
    actions: [
      {
        id: "create_ticket",
        name: "Create ticket",
        description: "Create a ticket in your ticketing system",
        type: "ticketing",
        config: {
          project: {
            type: "select",
            options: ["Security Engineering", "IT Operations", "DevOps"],
          },
          issueType: {
            type: "select",
            options: ["Epic", "Story", "Task", "Bug"],
          },
          summary: {
            type: "text",
            placeholder: "Issue Summary is Taken from gap",
          },
          description: {
            type: "text",
            placeholder: "Issue description is Taken from Gap",
          },
          assignee: {
            type: "select",
            options: ["Team-member", "Manager", "CISO"],
          },
          labels: {
            type: "multi-select",
            options: ["crowdstrike", "jamf", "okta", "breeze"],
          },
        },
        configValues: {
          project: "Security Engineering",
          issueType: "Story",
          summary: "Stale gap escalation for sensitive data",
          description:
            "High-severity gap affecting sensitive data assets needs immediate attention",
          assignee: "Manager",
          labels: ["security", "sensitive-data"],
        },
      },
      {
        id: "send_slack",
        name: "Send Slack Message",
        description: "Send a notification to Slack channel",
        type: "notification",
        config: {
          channel: {
            type: "select",
            options: ["#security", "#alerts", "#devops"],
          },
          message: {
            type: "text",
            placeholder: "Custom message",
          },
          mentions: {
            type: "multi-select",
            options: ["@channel", "@here", "@security-team"],
          },
        },
        configValues: {
          channel: "#security",
          message: "Stale gap alert - sensitive data at risk for over 14 days",
          mentions: ["@security-team"],
        },
      },
    ],
    createdAt: "2024-01-15T10:00:00Z",
    createdBy: "John Doe",
    inUse: true,
    available: true,
    active: false,
    id: 1,
  },
  {
    title: "Attack Surface Alert",
    description:
      "When a new applicable attack path with active events is detected, then send a Slack notification to the SecOps channel.",
    triggers: [
      {
        id: "attacker_activity",
        name: "Attacker Activity",
        description: "When suspicious attacker activity is detected",
        type: "threat",
        nextConditions: ["asset_type_check", "severity_check"],
      },
    ],
    conditions: [
      {
        id: "asset_type_is_Key People",
        name: "Key People",
        description: "Admins",
        type: {
          id: "asset_type_is",
          name: "Asset type is",
          description: "Check the asset type",
          type: "asset",
        },
        typeChildren: "Key People",
        fullName: "Asset type is Key People",
      },
    ],
    actions: [
      {
        id: "send_slack",
        name: "Send Slack Message",
        description: "Send a notification to Slack channel",
        type: "notification",
        config: {
          channel: {
            type: "select",
            options: ["#security", "#alerts", "#devops"],
          },
          message: {
            type: "text",
            placeholder: "Custom message",
          },
          mentions: {
            type: "multi-select",
            options: ["@channel", "@here", "@security-team"],
          },
        },
        configValues: {
          channel: "#alerts",
          message: "Attack surface alert - key personnel at risk",
          mentions: ["@channel", "@security-team"],
        },
      },
    ],
    createdAt: "2024-01-10T14:30:00Z",
    createdBy: "John Doe",
    inUse: true,
    available: true,
    active: false,
    id: 2,
  },
  {
    title: "Critical Asset Protection",
    description:
      "When a critical asset is affected by a high-severity gap, create a ticket and notify the security team.",
    triggers: [
      {
        id: "high_severity_gap",
        name: "High-Severity Gap",
        description: "When a high severity gap is detected",
        type: "security",
        nextConditions: ["tool_check", "asset_type_check", "assignee_check"],
      },
    ],
    conditions: [
      {
        id: "asset_type_is_Internal Application",
        name: "Internal Application",
        description: "Apps",
        type: {
          id: "asset_type_is",
          name: "Asset type is",
          description: "Check the asset type",
          type: "asset",
        },
        typeChildren: "Internal Application",
        fullName: "Asset type is Internal Application",
      },
      {
        id: "severity_is_critical",
        name: "Critical",
        description: "Critical",
        type: {
          id: "severity_is",
          name: "Severity is",
          description: "Check the severity level",
          type: "severity",
        },
        typeChildren: "CRITICAL",
        fullName: "Severity is Critical",
      },
    ],
    actions: [
      {
        id: "create_ticket",
        name: "Create ticket",
        description: "Create a ticket in your ticketing system",
        type: "ticketing",
        config: {
          project: {
            type: "select",
            options: ["Security Engineering", "IT Operations", "DevOps"],
          },
          issueType: {
            type: "select",
            options: ["Epic", "Story", "Task", "Bug"],
          },
          summary: {
            type: "text",
            placeholder: "Issue Summary is Taken from gap",
          },
          description: {
            type: "text",
            placeholder: "Issue description is Taken from Gap",
          },
          assignee: {
            type: "select",
            options: ["Team-member", "Manager", "CISO"],
          },
          labels: {
            type: "multi-select",
            options: ["crowdstrike", "jamf", "okta", "breeze"],
          },
        },
        configValues: {
          project: "Security Engineering",
          issueType: "Bug",
          summary: "Critical asset security vulnerability",
          description:
            "High-severity gap affecting critical internal application",
          assignee: "CISO",
          labels: ["critical", "security", "internal-app"],
        },
      },
      {
        id: "send_slack",
        name: "Send Slack Message",
        description: "Send a notification to Slack channel",
        type: "notification",
        config: {
          channel: {
            type: "select",
            options: ["#security", "#alerts", "#devops"],
          },
          message: {
            type: "text",
            placeholder: "Custom message",
          },
          mentions: {
            type: "multi-select",
            options: ["@channel", "@here", "@security-team"],
          },
        },
        configValues: {
          channel: "#security",
          message:
            "Critical asset protection alert - internal application at risk",
          mentions: ["@here", "@security-team"],
        },
      },
    ],
    createdAt: "2024-01-08T09:15:00Z",
    createdBy: "John Doe",
    inUse: true,
    available: true,
    active: true,
    missingTools: ["Jira"],
    id: 3,
  },
  {
    title: "Gap Discovery Notification",
    description:
      "When a new security gap is discovered, send immediate notification to security team.",
    triggers: [
      {
        id: "gap_discovered",
        name: "Gap discovered",
        description: "When a new security gap is identified",
        type: "security",
        nextConditions: [
          "severity_check",
          "tool_check",
          "assignee_check",
          "duration_check",
        ],
      },
    ],
    conditions: [
      {
        id: "severity_is_high",
        name: "High",
        description: "High",
        type: {
          id: "severity_is",
          name: "Severity is",
          description: "Check the severity level",
          type: "severity",
        },
        typeChildren: "HIGH",
        fullName: "Severity is High",
      },
    ],
    actions: [
      {
        id: "send_slack",
        name: "Send Slack Message",
        description: "Send a notification to Slack channel",
        type: "notification",
        config: {
          channel: {
            type: "select",
            options: ["#security", "#alerts", "#devops"],
          },
          message: {
            type: "text",
            placeholder: "Custom message",
          },
          mentions: {
            type: "multi-select",
            options: ["@channel", "@here", "@security-team"],
          },
        },
        configValues: {
          channel: "#alerts",
          message:
            "High-severity gap discovered - requires immediate attention",
          mentions: ["@security-team"],
        },
      },
    ],
    createdAt: "2025-11-05T09:02:03.122Z",
    createdBy: "talya@breeze-security.com",
    inUse: true,
    available: true,
    id: 4,
  },
  {
    title: "Multi-Condition Workflow",
    description:
      "Complex workflow with multiple conditions and actions for comprehensive gap handling.",
    triggers: [
      {
        id: "high_severity_gap",
        name: "High-Severity Gap",
        description: "When a high severity gap is detected",
        type: "security",
        nextConditions: ["tool_check", "asset_type_check", "assignee_check"],
      },
    ],
    conditions: [
      {
        id: "severity_is_high",
        name: "High",
        description: "High",
        type: {
          id: "severity_is",
          name: "Severity is",
          description: "Check the severity level",
          type: "severity",
        },
        typeChildren: "HIGH",
        fullName: "Severity is High",
      },
      {
        id: "tool_is_okta",
        name: "Okta",
        description: "Okta",
        type: {
          id: "tool_is",
          name: "Tool is",
          description: "Check the source tool",
          type: "tool",
        },
        typeChildren: "OKTA",
        fullName: "Tool is Okta",
      },
      {
        id: "has_assignee_no",
        name: "No",
        description: "No",
        type: {
          id: "has_assignee",
          name: "Has assignee",
          description: "Check if there's an assignee",
          type: "assignment",
        },
        typeChildren: "NO_ASSIGNEE",
        fullName: "Has assignee No",
      },
    ],
    actions: [
      {
        id: "create_ticket",
        name: "Create ticket",
        description: "Create a ticket in your ticketing system",
        type: "ticketing",
        config: {
          project: {
            type: "select",
            options: ["Security Engineering", "IT Operations", "DevOps"],
          },
          issueType: {
            type: "select",
            options: ["Epic", "Story", "Task", "Bug"],
          },
          summary: {
            type: "text",
            placeholder: "Issue Summary is Taken from gap",
          },
          description: {
            type: "text",
            placeholder: "Issue description is Taken from Gap",
          },
          assignee: {
            type: "select",
            options: ["Team-member", "Manager", "CISO"],
          },
          labels: {
            type: "multi-select",
            options: ["crowdstrike", "jamf", "okta", "breeze"],
          },
        },
        configValues: {
          project: "Security Engineering",
          issueType: "Epic",
          summary: "Unassigned Okta high-severity gap",
          description:
            "Critical Okta security gap requires immediate assignment and resolution",
          assignee: "Manager",
          labels: ["okta", "high-severity", "unassigned"],
        },
      },
    ],
    createdAt: "2025-11-05T12:47:27.009Z",
    createdBy: "talya@breeze-security.com",
    inUse: true,
    available: true,
    id: 5,
  },
];

// Custom hook to manage workflow data
// This will be easily replaceable with API calls when backend is ready
const useWorkflows = () => {
  const [workflows, setWorkflows] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  // Initialize workflows from localStorage or defaults
  useEffect(() => {
    const initializeWorkflows = () => {
      try {
        const storedWorkflows = localStorage.getItem(WORKFLOWS_STORAGE_KEY);
        if (storedWorkflows) {
          const parsedWorkflows = JSON.parse(storedWorkflows);
          setWorkflows(parsedWorkflows);
        } else {
          // Use default workflows if nothing in localStorage
          setWorkflows([...DEFAULT_WORKFLOWS]);
          localStorage.setItem(
            WORKFLOWS_STORAGE_KEY,
            JSON.stringify(DEFAULT_WORKFLOWS)
          );
        }
        setTemplates([...DEFAULT_WORKFLOWS_TEMPLATES]);
        setLoading(false);
      } catch (error) {
        console.error("Error loading workflows from localStorage:", error);
        // Fallback to defaults if localStorage is corrupted
        setWorkflows([...DEFAULT_WORKFLOWS]);
        setTemplates([...DEFAULT_WORKFLOWS_TEMPLATES]);
        setLoading(false);
      }
    };

    initializeWorkflows();
  }, []);

  // Save workflows to localStorage whenever workflows change
  useEffect(() => {
    if (!loading && workflows.length > 0) {
      try {
        localStorage.setItem(WORKFLOWS_STORAGE_KEY, JSON.stringify(workflows));
      } catch (error) {
        console.error("Error saving workflows to localStorage:", error);
      }
    }
  }, [workflows, loading]);

  const addWorkflow = (workflow) => {
    const newWorkflow = {
      ...workflow,
      id: workflow.id || Date.now().toString(),
      createdAt: workflow.createdAt || new Date().toISOString(),
    };
    setWorkflows((prev) => [...prev, newWorkflow]);
    return newWorkflow;
  };

  const updateWorkflow = (updatedWorkflow) => {
    setWorkflows((prev) =>
      prev.map((workflow) =>
        workflow.id === updatedWorkflow.id ? updatedWorkflow : workflow
      )
    );
  };

  const deleteWorkflow = (workflowId) => {
    setWorkflows((prev) =>
      prev.filter((workflow) => workflow.id !== workflowId)
    );
  };

  const toggleWorkflowStatus = (workflowId) => {
    setWorkflows((prev) =>
      prev.map((workflow) =>
        workflow.id === workflowId
          ? { ...workflow, inUse: !workflow.inUse }
          : workflow
      )
    );
  };

  const duplicateWorkflow = (workflowId) => {
    const workflowToDuplicate = workflows.find((w) => w.id === workflowId);
    if (workflowToDuplicate) {
      const duplicatedWorkflow = {
        ...workflowToDuplicate,
        id: Date.now().toString(),
        title: `${workflowToDuplicate.title} (Copy)`,
        createdAt: new Date().toISOString(),
        inUse: false, // Duplicated workflows start as inactive
      };
      setWorkflows((prev) => [...prev, duplicatedWorkflow]);
      return duplicatedWorkflow;
    }
  };

  const getWorkflowById = (workflowId) => {
    return workflows.find((workflow) => workflow.id === workflowId);
  };

  const getActiveWorkflows = () => {
    return workflows.filter((workflow) => workflow.inUse);
  };

  const getAvailableWorkflows = () => {
    return workflows.filter((workflow) => workflow.available);
  };

  const getWorkflowsByType = (type) => {
    return workflows.filter((workflow) =>
      workflow.triggers?.some((trigger) => trigger.type === type)
    );
  };

  const searchWorkflows = (searchTerm) => {
    if (!searchTerm) return workflows;

    const term = searchTerm.toLowerCase();
    return workflows.filter(
      (workflow) =>
        workflow.title?.toLowerCase().includes(term) ||
        workflow.description?.toLowerCase().includes(term) ||
        workflow.triggers?.some((trigger) =>
          trigger.name?.toLowerCase().includes(term)
        ) ||
        workflow.actions?.some((action) =>
          action.name?.toLowerCase().includes(term)
        )
    );
  };

  return {
    workflows,
    templates,
    loading,
    addWorkflow,
    updateWorkflow,
    deleteWorkflow,
    toggleWorkflowStatus,
    duplicateWorkflow,
    getWorkflowById,
    getActiveWorkflows,
    getAvailableWorkflows,
    getWorkflowsByType,
    searchWorkflows,
  };
};

export default useWorkflows;
